import React from "react";
import ContractForms from "./ContractForms";

export default function AddContract() {
  return <ContractForms type={"Add"}/>
}